import {
  getLocalAppleUserData,
  removeLocalAppleUserData
} from '../../../Enums/socialUser';
import { AppleSignUpAPI } from '../../../API/UserAPI';

export const buildGoogleParams = ({
  givenName,
  familyName,
  email,
  encodedToken
}) => ({
  firstName: (givenName || '').trim(),
  lastName: (familyName || '').trim(),
  email: email.trim(),
  idToken: encodedToken
});

export const buildAppleParams = ({
  tokenId: sub,
  email,
  givenName,
  familyName,
  encodedToken,
  code
}) => {
  let firstName = givenName || '';
  let lastName = familyName || '';

  // Apple only sends name on the first sign-in attempt; cache it locally to recover on retries
  const localAppleUserData = getLocalAppleUserData(sub);
  if (localAppleUserData) {
    if (!firstName) {
      firstName = localAppleUserData.firstName || '';
    }
    if (!lastName) {
      lastName = localAppleUserData.lastName || '';
    }
  }

  return {
    firstName,
    lastName,
    email: email.trim(),
    idToken: encodedToken,
    sub,
    code
  };
};

export const performAppleSignUp = async params => {
  const { sub, firstName, lastName, email, idToken } = params;

  const response = await AppleSignUpAPI({
    firstName,
    lastName,
    email,
    idToken
  });

  if (response.success) {
    removeLocalAppleUserData(sub);
  }

  return response;
};
